import HeroSection from '../components/Home/HeroSection';
import WhoAreWeSection from '../components/Home/WhoAreWeSection';
import OfficesSection from '../components/Home/OfficesSection';
import StatsSection from '../components/Home/StatsSection';
import TeamStatsSection from '../components/Home/TeamStatsSection';

function Home() {
  return (
    <div className="bg-white"> {/* <- kill the beige */}
      <HeroSection />
      <WhoAreWeSection />
      <StatsSection />
      <OfficesSection />
      <TeamStatsSection />
    </div>
  );
}

export default Home;
